import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import two_happy_woman from "../../../images/two_happy_woman.jpg";
import two_happy_face from "../../../images/tewo_woman_face.jpg";
import { EmotionPredictionTable, EmotionPredictionList } from '../../PredictionResultTable/PredictionResultTable';
import image1 from "../../../images/happy_girl.png";
import image2 from "../../../images/happy_elder.png";
import image3 from "../../../images/happy_man.png";
import ai_analysis from "../../../images/Emotion_analysis.png";
import discussion from "../../../images/discussion.png";
import ai_thinking from "../../../images/AI_thinking.png";
import ai_idea from "../../../images/ai_idea.png";
import ai_welcome from "../../../images/Welcome_ai.png";

import { useState } from "react";
import { motion } from "framer-motion";

export default function StudyOneInstructionPageTwo(){
        const googleDriveVideoIds = ["1Ymv-dAWCsZn69nl7hu41srB4rwNjIn6R",
    ];
    const [connecting, setConnecting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(["", "", ""]);

    const handleAnalyzeClick = () => {
        setConnecting(true);
        setResults(["", "", ""]);

        setTimeout(() => {
            setConnecting(false);
            setLoading(true);

            setTimeout(() => {
                setLoading(false);
                setResults(["Comtempt: 80.2%", "Anger 51.6%; Disgust 46.5%", "Happy: 99.9%"]);
            }, 1500);
        }, 1500);
    };
    const [showBubble, setShowBubble] = useState(false);

    const handleImageClick = () => {
        setShowBubble(true);
    }; 
    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold'}}>More happy faces!</h1>
                <br /><br /><br />
                <Container style={{width:"90%"}}>
                <Row className="align-items-start mb-4">
                    <Col xs={4} className="text-center">
                        <img 
                            src={ai_welcome} 
                            alt="FEAI icon" 
                            style={{ width: "150px", height: "150px", }} 
                        />
                    </Col>
                    <Col xs={6}>
                        <div className="chat-bubble">
                            <p>I capture more faces! </p>
                        </div>
                    </Col>
                </Row> 
                    <Row>
                        <p>EmoAI captures more faces......</p>
                    </Row>
                    
                    <Row className="text-center mb-3">
                        {[image1, image2, image3].map((imgSrc, idx) => (
                            <Col key={idx}>
                                <img
                                    src={imgSrc}
                                    alt={`Snapshot ${idx + 1}`}
                                    style={{
                                        width: "200px",
                                        height: "200px",
                                        objectFit: "cover",
                                    }}
                                />
                            </Col>
                        ))}
                    </Row>

                    <Row className="text-center mb-4">
                        {results.map((result, idx) => (
                            <Col key={idx} style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                                {result}
                            </Col>
                        ))}
                    </Row>


                    <Row className="text-center mb-5">
                        <Col>
                            <motion.button 
                                onClick={handleAnalyzeClick} 
                                disabled={connecting || loading}
                                className="button analyze-button"
                                title="Register Now!"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                {connecting ? (
                                    <>
                                        <Spinner animation="grow" size="sm" /> Connecting to EmoAI...
                                    </>
                                ) : loading ? (
                                    <>
                                        <Spinner animation="border" size="sm" /> Analyzing...
                                    </>
                                ) : (
                                    "Analyze Emotions"
                                )}
                            </motion.button>
                        </Col>
                    </Row>
                    
                    <p>Why do you think AI produced such results?</p>
                    <Row className="align-items-start mb-4">
                                <Col xs={4} className="text-center">
                                    <img 
                                        src={ai_idea} 
                                        alt="FEAI icon" 
                                        style={{ width: "150px", height: "150px", }} 
                                        onClick={handleImageClick}
                                    />
                                </Col>
                                <Col xs={6}>
                                {showBubble && (
                                <div className="chat-bubble">
                                    <p>
                                    <strong className="highlight">Age, gender and race</strong> impact the results!
                                    </p>
                                </div>
                                )}
                                </Col>
                        </Row> 
                   
                </Container>
            </Row>
        </Container>
    );
};